/**
 * 구글 로그인 유틸리티 (Firebase Auth 사용)
 */
import { signInWithPopup } from 'firebase/auth'
import { auth, googleProvider } from '../config/firebase'

/**
 * 구글 로그인 실행
 */
export const handleGoogleLogin = async (
  onSuccess: (providerId: string) => Promise<void>,
  onError: (error: string) => void
): Promise<void> => {
  try {
    const result = await signInWithPopup(auth, googleProvider)
    const user = result.user

    // Google의 실제 사용자 ID 가져오기 (앱과 동일한 ID 사용)
    // providerData에서 Google provider의 uid를 찾음
    const googleProviderData = user.providerData.find(
      (provider) => provider.providerId === 'google.com'
    )

    if (!googleProviderData || !googleProviderData.uid) {
      throw new Error('구글 로그인 정보를 가져올 수 없습니다.')
    }

    // Google의 실제 사용자 ID 사용 (앱의 GoogleSignInAccount.id와 동일)
    await onSuccess(googleProviderData.uid)
  } catch (error: any) {
    if (error.code === 'auth/popup-closed-by-user') {
      onError('구글 로그인이 취소되었습니다.')
    } else if (error.code === 'auth/popup-blocked') {
      onError('팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.')
    } else {
      onError(error.message || '구글 로그인 중 오류가 발생했습니다.')
    }
  }
}
